import config from './config'

const method = path => {
  const assetUrl = config('app.asset_url')

  if (assetUrl) {
    return assetUrl + '/' + path.replace(/^\/+/g, '')
  }

  return path
}

export default method
